<template>
  <div>
    <ul class="nav nav-tabs warehouse-amazon-nav-tabs" id="warehouse-amazon-tabs">
      <li v-for="item in navTabs" :key="item.id" :id="item.id" :class="activeTab(item.id)" @click="changeTab(item.id)">
        <a>{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import tabs from '@/common/warehouse-amazon-tabs'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      navTabs: tabs
    }
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    },
    changeTab (tabName) {
      let availableTabs = ['top', 'amazon-info', 'multi-channel-service', 'receive-amount-setting']
      if (availableTabs.includes(tabName)) {
        let tabsParamsName = {
          top: eventCode.warehouse_amazon.top_tab.show,
          amazon_info: eventCode.warehouse_amazon.amazon_info_tab.show,
          multi_channel_service: eventCode.warehouse_amazon.multi_channel_service_tab.show
        }
        let tabKey = tabName.replaceAll('-', '_')
        let logParams = {
          name: tabsParamsName[tabKey],
          properties: {}
        }
        EventService.postTrackLog(logParams)

        setTimeout(() => {
          $(`#${tabName}`).addClass('disabled-tab')
        }, 100)
      }
      this.$router.push(`/warehouse-amazon/${tabName}`)
    }
  },
  watch: {
    tab () {
      if (['amazon-info', 'multi-channel-service'].includes(this.tab)) {
        $('#warehouse-amazon-tabs').css('max-width', '920px')
      }
      if (['receive-amount-setting'].includes(this.tab)) {
        $('#warehouse-amazon-tabs').css('max-width', '840px')
      }
    }
  },
  mounted () {
    $(`#${this.tab}`).addClass('disabled-tab')
    if (['amazon-info', 'multi-channel-service'].includes(this.tab)) {
      $('#warehouse-amazon-tabs').css('max-width', '920px')
    }
    if (['receive-amount-setting'].includes(this.tab)) {
      $('#warehouse-amazon-tabs').css('max-width', '840px')
    }
  }
}
</script>

<style scoped>
.disabled-tab {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/NavTabs.vue